import { useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

export const query = graphql`
  query {
    allNodeNews(sort: {fields: field_news_date, order: DESC}) {
      edges {
        node {
          path {
            alias
          }
          field_news_type
          relationships {
            field_news_image {
              relationships {
                field_media_image_1 {
                  gatsbyImage(
                    quality: 100
                    placeholder: BLURRED
                    width: 380
                    height: 240
                  )
                }
              }
            }
          }
          field_news_date
          body {
            processed
          }
          title
        }
      }
    }
  }
`

const format = ({ edges }) => {
  return edges.map(({ node }) => {
    let image = false
    // @todo, handle default / fallback image.
    if (node.relationships.field_news_image) {
      image = node.relationships.field_news_image.relationships.field_media_image_1.gatsbyImage
    }

    return {
      title: node.title,
      body: node.body.processed,
      date: node.field_news_date,
      type: node.field_news_type,
      path: node.path.alias,
      image: image
    }
  })
}

export const useNews = () => {
  const { allNodeNews } = useStaticQuery(query)
  return useMemo(() => format(allNodeNews), [allNodeNews])
}